<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-title">驾校学习系统</div>
      <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          label-width="0"
          class="login-form"
      >
        <el-form-item prop="username">
          <el-input
              v-model="loginForm.username"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
              clearable
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
              clearable
              @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="captcha-row">
            <el-input
                v-model="loginForm.captcha"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                clearable
                @keyup.enter.native="handleLogin"
            />
            <img
                v-if="captchaImage"
                :src="captchaImage"
                alt="验证码"
                class="captcha-image"
                @click="loadCaptcha"
                title="点击刷新验证码"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              class="login-btn"
              :loading="loading"
              @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="login-footer">
      <span>网站主办单位：郑州市众鑫机动车驾驶员培训学校有限公司</span>
      <span class="footer-divider">|</span>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="hover-link">
        豫ICP备2026017669号
      </a>
      <span class="footer-divider">|</span>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41010202003859" target="_blank" class="hover-link gongan-link">
        <img src="@/assets/gongan.png" alt="公安备案图标" class="gongan-icon" />
        豫公网安备41010202003859号
      </a>
    </div>
  </div>
</template>

<script>
import { getCaptcha, login, getCurrentUser } from '@/api/auth'
import { setToken, removeToken } from '@/utils/auth'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      captchaImage: '',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaId: ''
      },
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.loadCaptcha()
  },
  methods: {
    async loadCaptcha() {
      try {
        const res = await getCaptcha()
        if (res.code === 200) {
          this.captchaImage = res.data.imageBase64
          this.loginForm.captchaId = res.data.captchaId
        } else {
          this.$message.error(res.message || '获取验证码失败')
        }
      } catch (e) {
        this.$message.error('获取验证码异常')
      }
    },

    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) {
          return
        }
        this.loading = true
        try {
          const res = await login(this.loginForm)

          if (res && res._handled401) {
            return
          }
          if (res.code !== 200) {
            this.$message.error(res.message || '登录失败')
            await this.loadCaptcha()
            return
          }

          const token = res.data ? res.data.token : ''
          if (!token) {
            this.$message.error('登录异常：未获取到 token')
            await this.loadCaptcha()
            return
          }

          setToken(token)

          const meRes = await getCurrentUser()

          if (meRes && meRes._handled401) {
            return
          }
          if (meRes.code !== 200) {
            removeToken()
            this.$store.commit('CLEAR_USER_INFO')
            this.$message.error(meRes.message || '获取用户信息失败')
            await this.loadCaptcha()
            return
          }

          const user = meRes.data || {}

          this.$store.commit('SET_USER_INFO', user)
          this.$message.success('登录成功')

          if (user.role === 'ADMIN') {
            this.$router.replace('/admin')
          } else {
            this.$router.replace('/student/home')
          }

        } catch (e) {
          removeToken()
          this.$store.commit('CLEAR_USER_INFO')
          this.$message.error('登录接口异常')
          await this.loadCaptcha()
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background: #2b6cb0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; /* 新增：为底部绝对定位提供参考 */
}

.login-box {
  width: 420px;
  padding: 40px 35px 20px;
  background: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}

.login-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 30px;
}

.login-form {
  width: 100%;
}

::v-deep .login-form .el-input__inner::placeholder {
  color: #ff9999;
}
::v-deep .login-form .el-input__inner::-webkit-input-placeholder {
  color: #ff9999;
}
::v-deep .login-form .el-input__inner::-moz-placeholder {
  color: #ff9999;
}
::v-deep .login-form .el-input__inner:-ms-input-placeholder {
  color: #ff9999;
}

.captcha-row {
  display: flex;
  align-items: center;
}

.captcha-image {
  width: 120px;
  height: 40px;
  margin-left: 10px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  flex-shrink: 0;
}

.login-btn {
  width: 100%;
}

/* ================= PC端 备案信息底部样式 ================= */
.login-footer {
  position: absolute;
  bottom: 25px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7); /* 蓝色背景搭配半透明白字 */
  z-index: 10;
}

.login-footer a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
}

.login-footer a:hover {
  color: #ffffff; /* 悬停变为纯白 */
}

.footer-divider {
  margin: 0 12px;
  color: rgba(255, 255, 255, 0.4);
}

.gongan-link {
  display: flex;
  align-items: center;
}

.gongan-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
</style>